export default {
    top_menu: [
        {name:'Main',    id:0},
        {name:'Show Business', id:1},
        {name:'Memasak',  id:2},
        {name:'Kebijakan',   id:3},
        {name:'Piquant',  id:4},
        {name:'Masyarakat',   id:5},
        {name:'Kesehatan',   id:6},
    ],
    read_other: 'Baca lebih lanjut',
    read_more:  'Detail',
    not_found:  'Tidak ada yang ditemukan',
    read_also:  'Baca juga',
    copy_rights: 'Hak Cipta © 2019 Mixer-novostei.ru. Semua hak dilindungi.',
    subscribe: 'Berlangganan',

    thank_order: 'TERIMA KASIH UNTUK PESANAN',
    specialist_contact: 'Spesialis kami akan segera menghubungi Anda, tunggu panggilan kami.',
    attention: 'Diskon dari mitra:',
    hurry: 'Cepat, waktu aktivasi diskon terbatas! Anda hanya memiliki <span id = "time" class = "time"> 30:00 </span> menit untuk memilih salah satu produk unik ini:',

    hour_ago1: "sejam yang lalu",
    hour_ago2: "jam yang lalu",
    hour_ago3: "jam yang lalu",
    new_publications: "Postingan baru",
    read: "Baca",
    today_at: "Hari ini di",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "Berita teratas",
    leave_already: "Anda ingin keluar? Tunggu berita yang baru saja kami perbarui",
    already_shared: "sudah dibagikan"
}
